/*
 * ListLink — Navigation drawer item
 *
 * Follows MD3 navigation-drawer specs:
 *   - Typography:  label-large (14 px, weight 500, line-height 1.33)
 *   - Icon size:   24 dp
 *   - Icon–label gap: 8 px (compact)
 *   - Padding:     4 px block, 12 px inline
 *   - Height:      44 px min (WCAG 2.5.5 AAA touch target)
 *   - Shape:       full-rounded pill (active indicator)
 *   - Active bg:   secondary-container
 *
 * Ref: https://m3.material.io/components/navigation-drawer/specs
 */

/* ─── Wrapper ─── */

.wrapper {
  list-style: none;
}

/* ─── Link ─── */

.link {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  display: flex;
  align-items: center;
  gap: var(--space-3);
  width: 100%;
  height: 3rem;
  min-height: 2.75rem;
  padding: 0 var(--space-4);
  border-radius: var(--shape-full);
  font-family: inherit;
  color: var(--md-on-surface-variant);
  background: transparent;
  border: none;
  text-align: start;
  text-decoration: none;
  cursor: pointer;
  position: relative;
}

.link::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: currentColor;
  opacity: 0;
  transition: opacity var(--motion-duration-short3);
  pointer-events: none;
}

@media (hover: hover) {
  .link:hover::before {
    opacity: var(--state-hover);
  }
}

.link:focus-visible::before {
  opacity: var(--state-focus);
}

.link:active::before {
  opacity: var(--state-pressed);
}

/* ─── Active indicator ─── */

.active {
  background: var(--md-secondary-container);
  color: var(--md-on-secondary-container);
  font-weight: 600;
}

.active .leading {
  color: var(--md-on-secondary-container);
}

/* ─── Slots ─── */

.leading {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  flex-shrink: 0;
  color: var(--md-on-surface-variant);
}

.label {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trailing {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.leading > svg {
  width: 1em;
  height: 1em;
  font-size: var(--icon-size-lg);
}

.trailing > svg {
  width: 1em;
  height: 1em;
  font-size: var(--icon-size-sm);
}
